export const loginSxs = {
  avatarResponsiveSx: {
    display: { xs: 'block', sm: 'flex', md: 'none' },
    alignSelf: 'center'
  },
  logoSx: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  loginFieldBoxSx: {
    marginTop: '24px'
  },
  subRightBoxSx: {
    width: '75%',
    maxWidth: '450px',
    paddingLeft: '1.65rem',
    paddingRight: '1.65rem'
  },

  inputProps: {
    textAlign: 'left', // Align text to the left
    display: 'flex', // Use flex for vertical alignment
    alignItems: 'center' // Center items vertically
  },
  inputLabelProps: {
    textAlign: 'left', // Align label text to the left
    width: '100%' // Full width for alignment
  },

  haveNotAccountTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-purple)'
  },

  containerSx: {
    height: '100%'
  },

  mainBoxSx: {
    display: 'flex',
    width: '100%',
    flexDirection: { xs: 'column', md: 'row' },
    height: '100vh', // Full viewport height
    overflow: 'hidden' // Prevent scrolling
  },
  leftBoxSx: {
    bgcolor: 'var(--color-purple-dark)',
    flex: 1,
    display: { xs: 'none', md: 'flex' },
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'hidden', // Ensure no scroll
    position: 'relative' // Enable positioning for children
  },
  avatarGroupSx: {
    bgcolor: 'var(--color-purple-dark)',
    width: '100%',
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'center',
    paddingTop: '4.5rem'
  },
  ratingBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  ratingSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },
  ratingScoreSx: { fontSize: 'var(--font-size-14)', fontWeight: 500 },
  reviewSx: { fontSize: 'var(--font-size-14)', fontWeight: 400 },
  imgSx: {
    width: '100%', // Full width
    height: '100%', // Full height
    objectFit: 'cover', // Ensures the image covers its container without clipping
    objectPosition: 'bottom' // Align image to the bottom
  },
  rightBoxSx: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  welcomeBackTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-30)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginTop: '12px'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '8px'
  },
  textFieldSx: {
    '& .MuiOutlinedInput-root': {
      border: '1px solid var(--color-border-muted)',
      borderRadius: '6px',
      '& fieldset': { border: 'none' }
    }
  },
  forgotTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    cursor: 'pointer',
    //marginRight: 'auto !important',
    marginLeft: 'auto !important',
    marginTop: '4px !important'
  },
  dividerSx: {
    marginTop: '24px'
  },
  dividerTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  sqspBtnTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)'
  },
  signUpTextBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  signUpTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  avatarSx: {
    height: '24px',
    width: '30px',
    marginRight: '10px',
    borderRadius: 0
  },
  rattingSx: {
    color: '#FEC84B'
  },
  rattingsTextColorSx: {
    color: 'var(--color-border)'
  },
  passwordEyeSx: {
    cursor: 'pointer'
  },
  loginStatusSx: {
    color: 'var(--color-secondary)'
  },
  loginButtonSx: {
    boxShadow: 'none'
  },
  loginRattingSx: {
    color: 'var(--color-purple-dark)'
  },
  reviewerTextColor: {}
};
